export default "__VITE_ASSET__DPHUgMDT__"